import { createIcon } from '@chakra-ui/react';

export const Eye = createIcon({
  displayName: 'Eye',
  viewBox: '0 0 24 16',
  path: (
    <g id="Eye-Open" data-name="Eye-Open" transform="translate(32 -20)">
      <path
        id="Path_2451"
        data-name="Path 2451"
        d="M8.137,0c7.819,0,11.971,7.28,11.971,8s-3.349,8-11.971,8S-3.893,8.893-3.893,8,.317,0,8.137,0Z"
        transform="translate(-28.107 20)"
        fill="#fff"
      />
      <path
        id="Path_2451_-_Outline"
        data-name="Path 2451 - Outline"
        d="M8.137,1A12.061,12.061,0,0,0,.083,4.2,11.864,11.864,0,0,0-2.876,8.021a10.156,10.156,0,0,0,2.631,3.76,11.659,11.659,0,0,0,3.4,2.238A12.549,12.549,0,0,0,8.137,15a12.264,12.264,0,0,0,4.944-.992,11.628,11.628,0,0,0,3.377-2.259,10.915,10.915,0,0,0,2.621-3.724,12.835,12.835,0,0,0-2.944-3.784A11.9,11.9,0,0,0,8.137,1m0-1c7.819,0,11.971,7.28,11.971,8s-3.349,8-11.971,8S-3.893,8.893-3.893,8,.317,0,8.137,0Z"
        transform="translate(-28.107 20)"
        fill="#135cb0"
      />
      <circle
        id="Ellipse_107"
        data-name="Ellipse 107"
        cx="4"
        cy="4"
        r="4"
        transform="translate(-24 24)"
        fill="#fff"
      />
      <path
        id="Ellipse_107_-_Outline"
        data-name="Ellipse 107 - Outline"
        d="M4,1A3,3,0,1,0,7,4,3,3,0,0,0,4,1M4,0A4,4,0,1,1,0,4,4,4,0,0,1,4,0Z"
        transform="translate(-24 24)"
        fill="#135cb0"
      />
    </g>
  ),
});
